import Vue from 'vue';
export function prompt(tip,duration=1200) {
  Vue.prototype.$message({
    type: '',
    message: tip,
    offset: 72,
    center: true,
    duration: duration,
    customClass: 'attribute-delete-message'
  });
}
